/**
 * Recommendation system configuration.
 * Single place for ignore threshold and first-five ordering; no service imports so constants always load first.
 */

/** After this many ignores, a test is no longer recommended (default 3). */
export const RECOMMENDATION_IGNORE_THRESHOLD = 3;

/** Weak-area count threshold: if user has ≥ this many weak areas <60%, recommend weak area before AI Exam. */
export const WEAK_AREA_AI_EXAM_THRESHOLD = 3;

/** Accuracy below this is considered weak (Netflix recommendation, getWeakestTopics). */
export const WEAK_THRESHOLD = 70;

/** First-ten test order; kept in sync with aiCoach.metadata.FIRST_TEN_IN_ORDER. */
const FIRST_TEN_ORDER: readonly string[] = [
  'traffic-lights-signals',
  'road-signs', 
  'priority-rules',
  'motorway-rules',
  'hazard-perception',
  'speed-safety',
  'bicycle-interactions',
  'road-markings',
  'risk-awareness',
  'night-visibility'
];

/** First-ten test order; used until user has completed 10 distinct tests. */
export const getFirstTenOrder = (): readonly string[] => FIRST_TEN_ORDER;
